import type { DataAction } from '../../../types/dataAction.type';
import type { CostFileTemplateField } from '../types';

export const UPDATE_COST_FILE_TEMPLATE_FIELD = 'UPDATE_COST_FILE_TEMPLATE_FIELD' as const;

type Payload = CostFileTemplateField & {
  mappingIndex: number;
};

export const updateCostFileTemplateField = (payload: Payload) => ({
  data: payload,
  type: UPDATE_COST_FILE_TEMPLATE_FIELD,
});

export type UpdateCostFileTemplateFieldAction = DataAction<typeof UPDATE_COST_FILE_TEMPLATE_FIELD, Payload>;
